import { render, staticRenderFns } from "./SmallArticleTeaser.vue?vue&type=template&id=0b8e0282&"
import script from "./SmallArticleTeaser.vue?vue&type=script&lang=js&"
export * from "./SmallArticleTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports